import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import {IRefreshExtractAction} from '../../../../ts/ServerApi/types/actionNames';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import {FeatureFlags} from '../../../../ts/FeatureFlags';
import {createExtractRefresh} from '../../../actions/spaces/CreateExtractRefreshAction';
import {IDataSourceInfo} from '../../../../ts/models/IDataSourceInfo';
import {SessionSiteSelectors} from '../../../selectors/SessionInfoSelectors';
import {getAppStore} from '../../../AppStore';
import {isSingleDatasourceWithExtract, isSingleEmbeddedDatasource} from './IEntityActionHelpers';
import {currentUserIsOwnerOrAdmin} from '../../../utils/MixedContentHelpers';
import { CreateExtractTasksMode } from '~src/extract/actions/CreateExtractTaskAction';

export const ScheduleRefreshWithBridgeEntityAction: IEntityAction<IDataSourceInfo, IRefreshExtractAction> = {
  name: EntityActionNames.ScheduleRefreshWithBridge,
  translateName: Messages.bridgeLegacySchedule_action,

  isVisible: (targetItems: IDataSourceInfo[], appState: AppState) => {
    const isExtractSSSEnabledForServer = FeatureFlags.selfServiceSchedulesForRefreshEnabled;
    const isExtractSSSEnabledForSite = SessionSiteSelectors.isSelfServiceSchedulesForRefreshEnabled(getAppStore().getState());
    const isExtractSSSEnabled = isExtractSSSEnabledForServer && isExtractSSSEnabledForSite;

    return isExtractSSSEnabled
      && isSingleDatasourceWithExtract(targetItems)
      && !isSingleEmbeddedDatasource(targetItems);
  },

  isClickable: (availableActions: IRefreshExtractAction, targetItems: IDataSourceInfo[]) => {
    const appState = getAppStore().getState();
    return currentUserIsOwnerOrAdmin(appState, targetItems[0]) || (availableActions && availableActions.refreshExtract);
  },

  createReduxAction: (targetItems: IContentInfo[]) => createExtractRefresh(targetItems, CreateExtractTasksMode.AllowScheduleOnlyOnClient)
};
